import { render, staticRenderFns } from "./NotificationSetup.vue?vue&type=template&id=7456b2a3"
import script from "./NotificationSetup.vue?vue&type=script&lang=js"
export * from "./NotificationSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports